import { track } from "./telemetry";

/** An undo this soon after a handle transform counts as undoing an accident. */
export const TRANSFORM_UNDO_WINDOW_MS = 5000;

type TransformKind = "rotate" | "resize";

let lastTransform: { kind: TransformKind; at: number; depth: number } | null = null;
let adjustSession: { changes: number } | null = null;

/**
 * Record a committed handle transform. `undoDepth` is the undo stack's
 * length right after the commit, so a later undo can tell whether it is
 * undoing this transform or something newer.
 */
export function noteFurnitureTransform(kind: TransformKind, undoDepth: number, now = Date.now()) {
  lastTransform = { kind, at: now, depth: undoDepth };
  if (adjustSession) adjustSession.changes++;
}

/** Called by the store before it pops an undo entry. */
export function noteUndo(undoDepth: number, now = Date.now()) {
  const last = lastTransform;
  lastTransform = null;
  if (!last || last.depth !== undoDepth) return;
  const ms = now - last.at;
  if (ms > TRANSFORM_UNDO_WINDOW_MS) return;
  track("furniture_transform_undone", { kind: last.kind, ms });
}

export function startAdjustSession() {
  adjustSession = { changes: 0 };
}

/** A nudge, or a move drag, inside Adjust mode. */
export function noteAdjustChange() {
  if (adjustSession) adjustSession.changes++;
}

export type AdjustExitMethod =
  | "done"
  | "canvas"
  | "other_piece"
  | "escape"
  | "view"
  | "deleted";

export function endAdjustSession(method: AdjustExitMethod) {
  const session = adjustSession;
  adjustSession = null;
  if (!session) return;
  track("furniture_adjust_mode_exited", { method, changes: session.changes });
}
